<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
              <div class="col">
                <select name="clientLocationID" v-model="clientLocationID" class="input" :disabled="designs_loading==true">
                  <option value="">All Locations</option>
                  <option value="1">ROI</option>
                  <option value="2">NI</option>
                  <option value="3">GB</option>
                  <option value="4">Export</option>
                  <option value="5">Australasia</option>
                </select>
              </div>

             <div class=" col">
                &nbsp;<input type="date" class="input" v-model="start_date" />
                
              </div>
              <div class=" col" >
                &nbsp;<input type="date" class="input" v-model="end_date" />
                
              </div>

              <div class="col">
                  <table class="table is-hoverable is-bordered " id="overviewtable" >
                    <tbody>
                      <tr>
                        <td class="">Total  Designs</td>
                        <td>{{ designs.length }}</td>
                      
                        </tr>
                    </tbody>
                  </table>
                </div>
            </div>
      </div>
        
      </div>
    
   

    <table class="table is-hoverable is-fullwidth is-size-7" id="designstable" >
    	<thead>
    		<tr>
        <th>Client Name</th>
        <th>Design Name</th>
        <th>Garment Name</th>
        <th>Range</th>
        <th>Date Added</th>
        
        
   	 	    </tr>
    	</thead>
    	<tbody>
		    <tr v-if="designs_loading===true">
          <td colspan="10"><strong>Loading designs ...</strong></td>
          </tr>
        <tr v-for="design in designs" v-bind:key="design.designID" v-show="designs_loading===false">
          <td >{{  design.clientname }}</td>
          <td >{{  design.designname }}</td>
          <td >{{  design.garmentname }}</td>
          <td >{{  design.range }}</td>
          <td >{{  design.dateadded }}</td>
        
			</tr>
      </tbody>
      
    </table>

    <button @click="exportXLS()" class="button is-info" >Export to Excel</button>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
//import SalesService from '@/services/SalesService.js';
import XLSX from 'xlsx';

export default {
  name:'DesignsUploaded',
  components: {
   	
  },
  data() {
    return {
      designs: [],
      clientLocationID: 1,
    
      start_date: this.getStartDate(),
        end_date: new Date().toISOString().slice(0,10),
      currentSort: 'count',
      currentSortDir: 'desc',
      
     accessToken: '',
     designs_loading:true,
     VUE_APP_ASP_URL:process.env.VUE_APP_ASP_URL,

     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getDesigns()
        });
      
    },
  methods: {
    async getAccessToken() {
        this.accessToken = await this.$auth.getTokenSilently()
    },
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('designstable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Uploaded Designs.xlsx')

	 },
   
    async getDesigns() {
      this.designs_loading=true;
      OrderService.getDesigns(this.accessToken, this.start_date, this.end_date, this.clientLocationID)
          .then(
            (designs => {
              
              this.$set(this, "designs", designs);
              this.designs_loading=false;
            }).bind(this)
          );
    },
    
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 31);
            return d.toISOString().slice(0,10);
             
        },
   
  },
  computed : {
     
     
  },

 
  mounted() {
    
  },
  watch: {
   
    start_date: function () {
     
      this.getDesigns()
    },
    end_date: function () {
     
      this.getDesigns()
    },
    clientLocationID: function () {
     
     this.getDesigns()
   },
  }
}



</script>


